import { useCurrentSubscription, useCurrentSubscriptionData } from 'features/subscription'
import { FILTER_KEY_TO_APP_PRODUCT } from 'helpers/smartSignalMappings'
import { useToast } from 'hooks'
import { useSmartSignalsEnabled } from 'hooks/api/smart_signals'
import { useEventsV4 } from 'hooks/events'
import { useEffect, useMemo } from 'react'

import { DateRangeContextProvider } from '../../../commonUI'
import { VisitHistory } from '../../components/VisitHistory/VisitHistory'
import { useFilterSearchParams } from '../../hooks/useFilterSearchParams'

export function IdentificationVisitsPage() {
  return (
    <DateRangeContextProvider>
      <Page />
    </DateRangeContextProvider>
  )
}

function Page() {
  const { showToast } = useToast()

  const { currentSubscriptionId: subscriptionId } = useCurrentSubscription()
  const { subscription } = useCurrentSubscriptionData()
  const highRecallEnabled = subscription?.featureSettings?.highRecallEnabled === true

  const { adaptedFilterValues } = useFilterSearchParams()
  const { data: enabledProducts } = useSmartSignalsEnabled(subscriptionId)

  const { highRecallId: _highRecallId, ...filterValuesWithoutHighRecall } = adaptedFilterValues
  const effectiveFilterValues = highRecallEnabled ? adaptedFilterValues : filterValuesWithoutHighRecall

  const sanitizedFilterValues = useMemo(() => {
    if (!enabledProducts) {
      return effectiveFilterValues
    }
    const enabledSet = new Set(enabledProducts)
    const result = { ...effectiveFilterValues }
    for (const [key, product] of Object.entries(FILTER_KEY_TO_APP_PRODUCT)) {
      if (!enabledSet.has(product)) {
        delete result[key as keyof typeof result]
      }
    }
    return result
  }, [effectiveFilterValues, enabledProducts])

  const queryV4 = useEventsV4({
    subscriptionId,
    ...sanitizedFilterValues,
  })

  useEffect(() => {
    if (queryV4.error) {
      showToast({
        message: 'An error occurred when displaying events. Please try again.',
        severity: 'error',
      })
    }
  }, [queryV4.error, showToast])

  return <VisitHistory query={queryV4} />
}
